/**
 * 語音 OTP 的來電顯示號碼（TwSMS 語音外撥的出線號碼）。
 *
 * 2026-09-07 實撥確認：撥出去的來電顯示是 03-388-3325（桃園市話），
 * 這是供應商 TwSMS 的號碼，不是森智聯或瓦斯行的——客戶看到的是一支陌生號碼。
 *
 * 之所以要把它寫在畫面上：目標客群多為長輩，陌生市話來電的接聽率很低，
 * 而語音驗證的整個價值就建立在「使用者願意接這通電話」上。事先告訴他們
 * 要等哪一支號碼，是零成本又最有效的補救。
 *
 * ⚠️ 這支號碼由供應商決定，我方無法指定（TwSMS Voice API 沒有 caller ID 參數）。
 * 若日後 TwSMS 換號或改成多號輪替，這裡就會變成錯誤資訊——改號時只需改這一處，
 * 但要記得改。
 */
export const VOICE_OTP_CALLER_ID = "03-388-3325";
